module.exports = __webpack_public_path__ + "static/media/avatar_41.61ed36a2.svg";